module.exports = __webpack_public_path__ + "static/media/identity-abstraack-flower-3.11d6b80d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-abstraack-flower-3.png
// module id = 246
// module chunks = 0